import { z } from "zod";

export const workspaceSchema = z.object({
	id: z.string().uuid(),
	name: z.string().min(1).max(255),
	slug: z
		.string()
		.min(1)
		.max(100)
		.regex(/^[a-z0-9-]+$/),
	createdAt: z.string().datetime(),
	updatedAt: z.string().datetime(),
});

export type Workspace = z.infer<typeof workspaceSchema>;
